import { render, staticRenderFns } from "./DHPowerBall.vue?vue&type=template&id=8229afaa&scoped=true"
import script from "./DHPowerBall.vue?vue&type=script&lang=js"
export * from "./DHPowerBall.vue?vue&type=script&lang=js"
import style0 from "./DHPowerBall.vue?vue&type=style&index=0&id=8229afaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8229afaa",
  null
  
)

export default component.exports